<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .tooltip-content {
    display: flex;
    flex-direction: column;
    width: 225px;
    gap: utils.in_rem(12px);
  }
  .license-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: utils.in_rem(12px);
  }
</style>

<script>
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Checkbox from "@sourcewhale/shared/svelte-design-system/components/atoms/Checkbox/Checkbox.svelte";
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import TrialChip from "@sourcewhale/shared/svelte-design-system/components/molecules/LicenseCard/Components/TrialChip.svelte";
  import { forceShowProjectsMarketingModalStore } from "../../../modals/MarketingModal/ProjectsMarketingModal/stores.js";
  import { getAdminPanelContext } from "../context";

  const {
    modifiedTeamStore,
    showAddLicensesModalStore,
    licenseModalInitialAdditionStore,
  } = getAdminPanelContext();

  let { value, kind, skeleton = false } = $props();

  let userIndex = $derived(
    $modifiedTeamStore.users.findIndex((user) => user.userId === value.userId)
  );

  let licenseIndex = $derived(
    $modifiedTeamStore.licenses.findIndex((license) => license.kind === kind)
  );

  let isUserTrial = $derived(
    ($modifiedTeamStore.users[userIndex]?.trialLicenses || []).includes(kind)
  );

  let disabled = $derived.by(
    () => isUserTrial || (!value.licenses[kind] && !value.available[kind])
  );

  let tooltip = $derived(
    isUserTrial ? "This is a trial license." : "License limit reached."
  );

  const getChecked = () => value.licenses[kind];
  const setChecked = (checked) => {
    if (disabled) return;
    if (userIndex < 0) return;
    const { users = [] } = $modifiedTeamStore;
    const user = users[userIndex];
    if (!checked) {
      if (user) {
        const innerLicenseIndex = user.licenses.indexOf(kind);
        if (innerLicenseIndex >= 0) {
          user.licenses.splice(innerLicenseIndex, 1);
        }
      }
    } else if (user && !user.licenses.includes(kind)) {
      user.licenses.push(kind);
    }
    $modifiedTeamStore.users[userIndex] = {
      ...$modifiedTeamStore.users[userIndex],
      user,
    };
    $modifiedTeamStore.licenses[licenseIndex] = {
      ...$modifiedTeamStore.licenses[licenseIndex],
      activeCount: $modifiedTeamStore.users.reduce(
        (acc, u) =>
          acc +
          (u.licenses.includes(kind) && !(u.trialLicenses || []).includes(kind)
            ? 1
            : 0),
        0
      ),
    };
  };

  const addLicenseOnClick = () => {
    if (kind === "projects") {
      if ($userStore.hasCrm) {
        const moreText =
          "You can’t add it on behalf of other teams. If you want to add it to this team, please log in with an account that belongs to the target team.";
        showToast({
          title: `Your account already has access to the Projects module. ${$userStore.isOnAnotherTeam ? moreText : ""}`,
          type: "danger",
        });
        return;
      }
      $forceShowProjectsMarketingModalStore = true;
      return;
    }
    $showAddLicensesModalStore = true;
    $licenseModalInitialAdditionStore = kind;
  };
</script>

<div class="license-checkbox">
  {#if disabled}
    <Tooltip let:onblur let:onfocus let:onmouseenter let:onmouseleave>
      <div class="tooltip-content" slot="tooltip">
        {tooltip}
        {#if !isUserTrial}
          <Button
            onclick={addLicenseOnClick}
            style="width:100%"
            size="xsmall"
            kind="primary"
            leadingIcon="far fa-cart-shopping"
          >
            Add Licenses
          </Button>
        {/if}
      </div>
      <Checkbox
        bind:checked={getChecked, setChecked}
        {skeleton}
        disabled={true}
        {onblur}
        {onfocus}
        {onmouseenter}
        {onmouseleave}
      />
    </Tooltip>
  {:else}
    <Checkbox bind:checked={getChecked, setChecked} {skeleton} />
  {/if}
  {#if isUserTrial}
    <TrialChip status="trial" />
  {/if}
</div>
